<template>
  <div class="cus-search" :style="[boxStyle]">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "cus-search",
    props: {
      padding: {
        type: String, Number,
        default: '20px 20px 1px'
      },
      showBorder: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      boxStyle(){
        let style = {};
        style.padding = this.padding;
        if (this.showBorder) {
          style.borde = '1px solid #e6ebf5';
          style.boxShadow = '0 2px 12px 0 #e6ebf5'
        }
        return style;
      }
    }
  }
</script>

<style scoped lang="less">
  .cus-search {
    width: 100%;
    background: #FFFFFF;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/cuview-ui/components/cus-search/cus-search.vue